<script setup lang="ts">
import AttachmentList from '@/onenetwork/components/attachment_list/AttachmentList.vue'

interface Props {
  data: object | string | number,
  cellConfig: Object,
}

const props = defineProps<Props>()
</script>

<template>
  <div class="attachment_cell">
    <AttachmentList :data="props.data"/>
  </div>
</template>

<style scoped>

</style>
